import React from "react";

import { PaymentIntentSummaryDTO } from "../../../../models/EnrollmentHistoryDTO";

/*
	Tickets que mandó el alumno desde "Reporta tu pago" (/pagar, 2026-10-10). Pueden no estar ligados a
	un alumno de WAPP (el teléfono no dio con uno solo del plantel): entonces se ve lo que escribió y
	Caja busca a quién aplicarlo.
*/
export const EtiquetaAlumno: React.FC = () => (
	<span style={{ display: "inline-block", padding: "0 8px", borderRadius: 999, background: "transparent", color: "var(--wa-oro)", border: "1px solid var(--wa-oro)",
		fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", verticalAlign: 1 }}>Lo envió el alumno</span>
);

export const nombreDelTicket = (r: PaymentIntentSummaryDTO): string => r.studentName || r.contactName || "-";

/** Debajo del nombre: el correlativo, o "Sin alumno en WAPP" si no se encontró. */
export const SubNombre: React.FC<{ r: PaymentIntentSummaryDTO }> = ({ r }) => r.studentId
	? <div style={{ fontSize: 13, color: "var(--wa-apagado)" }}>{r.identityCode || "-"}</div>
	: <div style={{ fontSize: 13, color: "var(--wa-oro)" }}>Sin alumno en WAPP</div>;

/** Lo que el alumno escribió: teléfono (con lada, solo dígitos, como Woztell), correo y país, en una línea. */
export const contactoDelAlumno = (r: PaymentIntentSummaryDTO): string =>
	[r.contactPhone, r.contactEmail, r.contactCountry].filter((x) => x && String(x).trim() !== "").join(" · ");
